import "./index.css";

if (import.meta.env.PROD) {
  const script = document.createElement("script");
  script.defer = true;
  script.src = "https://analytics.damiannicholson.com/script.js";
  script.dataset.websiteId = "abfe7382-b4a1-4a6d-8473-1512dd4be1cd";
  document.head.appendChild(script);
}
import "./i18n";
import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { Toaster } from "sonner";
import { Footer } from "./components/ui/Footer";
import { Navbar } from "./components/ui/Navbar";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Build } from "./pages/Build";
import { Home } from "./pages/Home";
import { Leaderboard } from "./pages/Leaderboard";
import { NotFound } from "./pages/NotFound";
import { Party } from "./pages/Party";
import { UserProfile } from "./pages/UserProfile";

function ScrollToTop() {
  const { pathname } = useLocation();
  // biome-ignore lint/correctness/useExhaustiveDependencies: pathname is the trigger, not used inside the effect body
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  if (isLoading) {
    return (
      <main className="min-h-screen bg-stone-50 dark:bg-stone-950 pt-14 flex items-center justify-center">
        <div className="w-5 h-5 rounded-full border-2 border-stone-300 dark:border-stone-700 border-t-amber-500 animate-spin" />
      </main>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return <>{children}</>;
}

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="bottom-center" richColors />
        <Navbar />
        <ScrollToTop />
        <div className="flex flex-col min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/build"
              element={
                <ProtectedRoute>
                  <Build />
                </ProtectedRoute>
              }
            />
            <Route
              path="/build/:slug"
              element={
                <ProtectedRoute>
                  <Build />
                </ProtectedRoute>
              }
            />
            <Route path="/party/:slug" element={<Party />} />
            <Route path="/party/:slug/comments" element={<Party />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/user/:id" element={<UserProfile />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </div>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
